import React, { useContext } from 'react'

import { faAdd } from '@fortawesome/pro-solid-svg-icons'
import IconButton from '../../../Components/antd/Buttons/IconButton'
import { Quota } from '../../../utils/entities/quota'
import { QuotaFormModalContext, Types } from './QuotaFormModalProvider'

const QuotaFormButton = ({ icon = faAdd, seed = {}, text = '', callback }) => {
  const { setFormHandler } = useContext(QuotaFormModalContext)

  return (
    <IconButton
      icon={icon}
      text={text}
      type='primary'
      onClick={() => setFormHandler({ data: new Quota(seed), callback, type: Types.QUOTA })}
    />
  )
}

export default QuotaFormButton
